module.exports = __webpack_public_path__ + "media/3.a1430ee9.mp3";